import { createAction, props } from '@ngrx/store';

export const loadBuiltInInsights = createAction('[Live Built In Insights/API] Load Built In Insights', props<{ force?: boolean }>());

export const loadBuiltInInsightsInProgress = createAction('[Live Built In Insights/API] Load Built In Insights in progress');

export const loadBuiltInInsightsSuccess = createAction(
  '[Live Built In Insights] Load Built In Insights success',
  props<{ builtInInsights: Microsoft.VideoIndexer.Live.Contracts.IBuiltInInsight[] }>()
);

export const loadBuiltInInsightsFailed = createAction('[Live Built In Insights] Load Built In Insights failed');
